import React, { useState } from 'react';
import { convocatorias } from '../../json/convocatorias';
import './convocatorias.css';

const ICONOS = {
  fecha: (<><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" /></>),
  sede: (<><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" /></>),
  cupo: (<><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" /></>),
};

const Icono = ({ tipo }) => (
  <svg
    className="icono-dato"
    viewBox="0 0 24 24"
    width="14"
    height="14"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {ICONOS[tipo]}
  </svg>
);

const ConvocatoriasNew = () => {
  const agruparPorAño = () => {
    const agrupadas = {};
    
    convocatorias.forEach(convocatoria => {
      const año = convocatoria.año || new Date().getFullYear();
      
      if (!agrupadas[año]) {
        agrupadas[año] = [];
      }
      
      agrupadas[año].push(convocatoria);
    });
    
    return agrupadas;
  };

  const convocatoriasPorAño = agruparPorAño();
  const años = Object.keys(convocatoriasPorAño).sort((a, b) => b - a);
  
  
  const [añosExpandidos, setAñosExpandidos] = useState(() => {
    const estadoInicial = {};
    
    años.forEach(año => {
      if (año === "2026") {
        estadoInicial[año] = true; 
      } else {
        estadoInicial[año] = false; 
      }
    });
    
    return estadoInicial;
  });

  const toggleAño = (año) => {
    setAñosExpandidos(prev => ({
      ...prev,
      [año]: !prev[año]
    }));
  };

  const expandirTodo = () => {
    const todosExpandidos = {};
    años.forEach(año => {
      todosExpandidos[año] = true;
    });
    setAñosExpandidos(todosExpandidos);
  };

  const colapsarTodo = () => {
    const todosColapsados = {};
    años.forEach(año => {
      todosColapsados[año] = false;
    });
    setAñosExpandidos(todosColapsados);
  };

  const expandirSoloAño = (añoExpandir) => {
    const nuevoEstado = {};
    años.forEach(año => {
      nuevoEstado[año] = (año === añoExpandir);
    });
    setAñosExpandidos(nuevoEstado);
  };

  return (
    <div className="pagina-convocatorias">
      <header className="encabezado-pagina">
        <h1 className="titulo-pagina">Catálogo de convocatorias</h1>
        <p className="subtitulo-pagina">Descubre las oportunidades para artistas y creadores en Hidalgo</p>
        
        <div className="controles-años">
          <button onClick={expandirTodo} className="btn-control-año">
            Expandir todos los años
          </button>
          <button onClick={colapsarTodo} className="btn-control-año">
            Colapsar todos los años
          </button>
          <button 
            onClick={() => expandirSoloAño("2026")} 
            className="btn-control-año btn-especial"
          >
            Ver solo 2026
          </button>
          <button 
            onClick={() => expandirSoloAño("2025")} 
            className="btn-control-año btn-especial"
          >
            Ver solo 2025
          </button>
        </div>
      </header>
      
      <main className="contenedor-convocatorias">
        {años.map(año => (
          <section key={año} className="seccion-año">
            <div 
              className="encabezado-año"
              onClick={() => toggleAño(año)}
            >
              <h2 className="titulo-año">
                Convocatorias {año}
                <span className="contador-convocatorias">
                  ({convocatoriasPorAño[año].length})
                </span>
                {!añosExpandidos[año] && (
                  <span className="badge-colapsado">(Colapsado)</span>
                )}
              </h2>
              <div className="icono-expandir">
                {añosExpandidos[año] ? '−' : '+'}
              </div>
            </div>
            
            {añosExpandidos[año] && (
              <div className="contenido-año">
                <div className="grid-convocatorias">
                  {convocatoriasPorAño[año].map((convocatoria, index) => {
                    const claseEstado =
                      convocatoria.estado === "CONVOCATORIA CERRADA" ? "cerrada"
                      : convocatoria.estado === "CONVOCATORIA ABIERTA" ? "abierta"
                      : "resultados";
                    const nombre = convocatoria.nombre || convocatoria.titulo;

                    return (
                      <div key={index} className="tarjeta-convocatoria">
                        <a
                          href={convocatoria.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="enlace-convocatoria"
                        >
                          <div className="tarjeta-imagen">
                            <img src={convocatoria.imagen} alt={nombre} loading="lazy" />
                            {convocatoria.estado && (
                              <span className={`badge-urgente ${claseEstado}`}>
                                {convocatoria.estado}
                              </span>
                            )}
                          </div>

                          <div className="tarjeta-cuerpo">
                            <h3 className="titulo-convocatoria">{nombre}</h3>

                            {convocatoria.descripcion && (
                              <p className="descripcion-convocatoria">{convocatoria.descripcion}</p>
                            )}

                            <ul className="datos-convocatoria">
                              {convocatoria.nombre && convocatoria.titulo && (
                                <li><Icono tipo="fecha" />{convocatoria.titulo}</li>
                              )}
                              {convocatoria.sede && (
                                <li><Icono tipo="sede" />{convocatoria.sede}</li>
                              )}
                              {convocatoria.cupo && (
                                <li><Icono tipo="cupo" />{convocatoria.cupo}</li>
                              )}
                            </ul>

                            <span className="boton-convocatoria">Ver detalles</span>
                          </div>
                        </a>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </section>
        ))}
      </main>
    </div>
  );
};

export default ConvocatoriasNew;